import utils, {axiosWithAuth} from '@imt/vue-toolbox/src/utils';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const axios = axiosWithAuth(`${process.env.VUE_APP_ADMIN_URL_USERS}/api/v1/`);

export const getters = {
    notificationIcon: () => type => {
        let types = {
            'alert': 'exclamation-triangle',
            'assigned': 'user-plus',
            'complete': 'check-square',
            'group-message': 'comments',
            'info': 'info-circle',
            'message': 'comment',
            'permission-granted': 'unlock-alt',
            'published': 'check-circle',
            'scheduled': ['far', 'clock'],
            'set': ['far', 'clipboard-list-check'],
            'warning': 'exclamation-circle',
        };

        return types[type] || 'info-circle';
    },
    notificationTypes() {
        return [
            'assigned',
            'alert',
            'complete',
            'group-message',
            'info',
            'message',
            'permission-granted',
            'published',
            'scheduled',
            'set',
            'warning',
        ];
    },
    unreadNotificationCount(state) {
        return state.notifications.filter(n => n.readAt === null).length;
    },
};

export const actions = {
    async fetchNotifications({commit, state}) {
        const response = await axios.get(`notifications/?page[size]=${state.fetchLimit}`);

        if (response.status === 200) {
            commit('SET_NOTIFICATIONS', utils.dataFormatter.deserialize(response.data));
        }
    },
    async markNotification({commit}, notificationId, read = true) {
        const response = await axios.patch(`notifications/${notificationId}/`, utils.dataFormatter.serialize({
            stuff: {
                type: 'Notification',
                id: notificationId,
                read,
            },
        }));

        if (response.status === 200) {
            commit('UPDATE_NOTIFICATION', utils.dataFormatter.deserialize(response.data));
        }
    },
};

export const mutations = {
    ADD_NOTIFICATION(state, notification) {
        if (!state.notifications.find(n => n.id === notification.id)) {
            if (state.notifications.length + 1 > state.fetchLimit) {
                state.notifications.pop();
            }

            state.notifications = [
                notification,
                ...state.notifications,
            ];
        }
    },
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications.map(n => {
            try {
                return {
                    ...n,
                    data: JSON.parse(n.data),
                };
            } catch (ex) {
                return n;
            }
        });
    },
    UPDATE_NOTIFICATION(state, notification) {
        state.notifications = state.notifications.map(n => {
            if (n.id === notification.id) {
                try {
                    return {
                        ...notification,
                        data: JSON.parse(notification.data),
                    };
                } catch (ex) {
                    return notification;
                }
            }

            return n;
        });
    },
};

export const state = () => {
    return {
        fetchLimit: 10,
        notifications: [],
    };
};

export default {
    namespaced: true,
    getters,
    actions,
    mutations,
    state: state(),
};
